import { LYKA_TOPPER_FEEDING_PLAN_TYPES } from '@lyka-pet-food/contracts'

/**
 * Whether this feeding plan type is a Topper plan.
 * A Topper starter box is included, because that plan type is Topper as well.
 * The argument is a string because an order stores its plan type as text.
 */
export function isTopperPlanType(planType: string | null | undefined): boolean {
  if (planType == null) return false
  for (const topperType of LYKA_TOPPER_FEEDING_PLAN_TYPES) {
    if (topperType === planType) return true
  }
  return false
}
